import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Styles from "../styles/components/HomeWorkSection.module.scss"

const Image = props => (
  <StaticQuery
    query={graphql`
      query {
        images: allFile {
          edges {
            node {
              relativePath
              name
              childImageSharp {
                fluid(maxWidth: 1980) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const image = data.images.edges.find(n => {
        return n.node.relativePath.includes(props.filename)
      })
      if (!image) {
        return null
      }

      //const imageSizes = image.node.childImageSharp.sizes; sizes={imageSizes}
      return <Img alt={props.alt} className={Styles["section-portfolioCard-img"]} fluid={image.node.childImageSharp.fluid} style={{position: "absolute"}} />
    }}
  />
)
export default Image
